const kioskSurveyForm = {
  "id": "kiosk",
  "title": "Kiosk Survey",
  "description": "Kiosk wise Detailed Information should be furnished",
  "sections": [
    {
      "id": "a",
      "title": "General Information",
      "questions": [
        {
          "id": "A1",
          "label": "A1",
          "question": "Whether kiosk remains functional everyday including on holidays. If NO, specify the reason in the remark coloumn for non functioning everyday.",
          "type": "radio",
          "options": [
            { "label": "YES", "value": "yes" },
            { "label": "NO", "value": "no" }
          ],
          "helperText": "Upload the supporting orders from ULB",
          "fields": [
            {
              "id": "remark",
              "type": "textarea",
              "label": "Remarks",
              "placeholder": "Enter remarks",
              "showWhen": ["no"]
            },
            {
              "id": "file",
              "type": "file",
              "label": "Upload supporting file",
              "accept": "image/*,.pdf,.doc,.docx",
              "helperText": "Upload the supporting orders from ULB",
              "showWhen": ["yes"]
            }
          ]
        },
        {
          "id": "A2",
          "label": "A2",
          "question": "Whether kiosk is operated by SHGs or others. If others, specify in the remark coloumn, who are operating and the reason for non-engagement of SHGs.",
          "type": "radio",
          "options": [
            { "label": "SHGs", "value": "shgs" },
            { "label": "Others", "value": "others" }
          ],
          "helperText": "",
          "fields": [
            {
              "id": "remark",
              "type": "textarea",
              "label": "Remarks",
              "placeholder": "Enter remarks",
              "showWhen": ["others"]
            }
          ]
        },
        {
          "id": "A3",
          "label": "A3",
          "question": "Mention the number of staff engaged in the functioning of kiosk",
          "type": "number",
          "options": [],
          "helperText": "",
          "fields": []
        },
        {
          "id": "A4",
          "label": "A4",
          "question": "Timing for service of meal (Guideline Stated Timing from 12 NOON to 3 PM)",
          "type": "time-range",
          "options": [],
          "helperText": "",
          "fields": [
            {
              "id": "from",
              "type": "time",
              "label": "From",
              "showWhen": []
            },
            {
              "id": "to",
              "type": "time",
              "label": "To",
              "showWhen": []
            }
          ]
        },
        {
          "id": "A5",
          "label": "A5",
          "question": "Average Number of beneficiaries benefitted per DAY",
          "type": "number",
          "options": [],
          "helperText": "",
          "fields": []
        },
        {
          "id": "A6",
          "label": "A6",
          "question": "Whether receipt of Food Coupons preserved at ULB level for future reference and Audit purpose",
          "type": "radio",
          "options": [
            { "label": "YES", "value": "yes" },
            { "label": "NO", "value": "no" }
          ],
          "helperText": "",
          "fields": []
        }
      ]
    },
    {
      "id": "b",
      "title": "Quality & Quantity Assessment of Served Food",
      "questions": [
        {
          "id": "B1",
          "label": "B1",
          "question": "How would you rate the quality of the meal served?",
          "type": "radio",
          "options": [
            { "label": "Good", "value": "good" },
            { "label": "Satisfactory", "value": "satisfactory" },
            { "label": "Poor", "value": "poor" }
          ],
          "helperText": "",
          "fields": []
        },
        {
          "id": "B2",
          "label": "B2",
          "question": "How would you rate the quantity of meal served",
          "type": "radio",
          "options": [
            { "label": "Good", "value": "good" },
            { "label": "Satisfactory", "value": "satisfactory" },
            { "label": "Poor", "value": "poor" }
          ],
          "helperText": "",
          "fields": []
        },
        {
          "id": "B3",
          "label": "B3",
          "question": "Are all specified items ( ie. Rice, Dal, Sabji and One full Tabled egg) being served everyday",
          "type": "radio",
          "options": [
            { "label": "YES", "value": "yes" },
            { "label": "NO", "value": "no" }
          ],
          "helperText": "",
          "fields": []
        }
      ]
    },
    {
      "id": "c",
      "title": "Water Safety",
      "questions": [
        {
          "id": "C1",
          "label": "C1",
          "question": "Is there a provision for safe and potable drinking water for beneficiaries at the kiosk?",
          "type": "radio",
          "options": [
            { "label": "YES", "value": "yes" },
            { "label": "NO", "value": "no" }
          ],
          "helperText": "",
          "fields": []
        },
        {
          "id": "C2",
          "label": "C2",
          "question": "If YES, mention what arrangement made for proving safe drinking water to the beneficiaries?",
          "type": "radio",
          "options": [
            { "label": "YES", "value": "yes" },
            { "label": "NO", "value": "no" }
          ],
          "helperText": "Upload the picture of the drinking water point",
          "fields": [
            {
              "id": "photo",
              "type": "file",
              "label": "Capture or upload photo",
              "accept": "image/*",
              "helperText": "Upload the picture of the drinking water point",
              "capture": "environment",
              "showWhen": ["yes"]
            }
          ]
        },
        {
          "id": "C3",
          "label": "C3",
          "question": "Is the drinking water being tested for chemical and bacteriological parameters in every six months, with records maintained?",
          "type": "radio",
          "options": [
            { "label": "YES", "value": "yes" },
            { "label": "NO", "value": "no" }
          ],
          "helperText": "Please mention the last date of the water quality testing and upload the corresponding test report.",
          "fields": [
            {
              "id": "date",
              "type": "date",
              "label": "Last water quality testing date",
              "showWhen": ["yes"]
            },
            {
              "id": "file",
              "type": "file",
              "label": "Upload supporting file",
              "accept": "image/*,.pdf,.doc,.docx",
              "helperText": "Please mention the last date of the water quality testing and upload the corresponding test report.",
              "showWhen": ["yes"]
            }
          ]
        }
      ]
    },
    {
      "id": "d",
      "title": "General cleanliness of distribution area",
      "questions": [
        {
          "id": "D.1",
          "label": "D.1",
          "question": "Does the kiosk have adequate space for food distribution?",
          "type": "radio",
          "options": [
            { "label": "YES", "value": "yes" },
            { "label": "NO", "value": "no" }
          ],
          "helperText": "",
          "fields": []
        },
        {
          "id": "D.2",
          "label": "D.2",
          "question": "Does the kiosk maintains hygiene while handling and distributing food to the beneficiaries? Tick the applicable option. If all hygiene conditions are not met, please specify the gaps in the remarks column.",
          "type": "checkbox",
          "options": [
            { "label": "Clean and stain free utensils", "value": "clean_and_stain_free_utensils" },
            { "label": "Clean serving counters and food contact surfaces.", "value": "clean_serving_counters_and_food_contact_surfaces" },
            { "label": "Use of clean long handle spoons for serving food", "value": "use_of_clean_long_handle_spoons_for_serving_food" },
            { "label": "Food kept covered during storage.", "value": "food_kept_covered_during_storage" },
            { "label": "Not all the conditions met", "value": "not_all_the_conditions_met" }
          ],
          "helperText": "",
          "fields": [
            {
              "id": "remark",
              "type": "textarea",
              "label": "Remarks",
              "placeholder": "Enter remarks",
              "showWhen": ["not_all_the_conditions_met"]
            }
          ]
        },
        {
          "id": "D.3",
          "label": "D.3",
          "question": "Is the distribution area being cleaned and sanitised daily before and after distribution of food at kiosk and whether the process is recorded in housekeepig checklist? If the cleaning process is daily recorded in housekeeping checklist, assign YES.",
          "type": "radio",
          "options": [
            { "label": "YES", "value": "yes" },
            { "label": "NO", "value": "no" }
          ],
          "helperText": "Upload the latest housekeeping record for verification.",
          "fields": [
            {
              "id": "file",
              "type": "file",
              "label": "Upload supporting file",
              "accept": "image/*,.pdf,.doc,.docx",
              "helperText": "Upload the latest housekeeping record for verification.",
              "showWhen": ["yes"]
            }
          ]
        },
        {
          "id": "D.4",
          "label": "D.4",
          "question": "How would you rate the overall cleanliness of the kiosk",
          "type": "radio",
          "options": [
            { "label": "Good", "value": "good" },
            { "label": "Satisfactory", "value": "satisfactory" },
            { "label": "Poor", "value": "poor" }
          ],
          "helperText": "",
          "fields": []
        }
      ]
    },
    {
      "id": "e",
      "title": "Safety Arrangements",
      "questions": [
        {
          "id": "E.1",
          "label": "E.1",
          "question": "Is an overhead shed available at the kiosk to provide protection to the beneficiaries from excessive heat and rainfall?",
          "type": "radio",
          "options": [
            { "label": "YES", "value": "yes" },
            { "label": "NO", "value": "no" }
          ],
          "helperText": "",
          "fields": []
        },
        {
          "id": "E.2",
          "label": "E.2",
          "question": "Is the kiosk situated at a location that is free from water stagnation and not prone to flooding?",
          "type": "radio",
          "options": [
            { "label": "YES", "value": "yes" },
            { "label": "NO", "value": "no" }
          ],
          "helperText": "",
          "fields": []
        }
      ]
    },
    {
      "id": "f",
      "title": "Sanitation",
      "questions": [
        {
          "id": "F.1",
          "label": "F.1",
          "question": "Is there a dedicated functional toilet for canteen staff near kiosk? (*Functionality of toilet means availability of running water for flushing and cleaning, non-choking toilet pans and urinals, functional cisterns, washbasin with soap and water for handwash and proper drainage system).",
          "type": "radio",
          "options": [
            { "label": "YES", "value": "yes" },
            { "label": "NO", "value": "no" }
          ],
          "helperText": "",
          "fields": []
        },
        {
          "id": "F.2",
          "label": "F.2",
          "question": "Are the toilets well ventilated, illuminated and maintain privacy?",
          "type": "radio",
          "options": [
            { "label": "YES", "value": "yes" },
            { "label": "NO", "value": "no" }
          ],
          "helperText": "",
          "fields": []
        },
        {
          "id": "F.3",
          "label": "F.3",
          "question": "Are the toilets cleaned everyday and recorded in housekeeping checklist? (Check the housekeeping checklist and if updated daily, assign YES)",
          "type": "radio",
          "options": [
            { "label": "YES", "value": "yes" },
            { "label": "NO", "value": "no" }
          ],
          "helperText": "Upload the current month's housekeeping record for verification",
          "fields": [
            {
              "id": "file",
              "type": "file",
              "label": "Upload supporting file",
              "accept": "image/*,.pdf,.doc,.docx",
              "helperText": "Upload the current month's housekeeping record for verification",
              "showWhen": ["yes"]
            }
          ]
        },
        {
          "id": "F.4",
          "label": "F.4",
          "question": "Is there a covered dustbin in staff's toilet for disposal of sanitary waste?",
          "type": "radio",
          "options": [
            { "label": "YES", "value": "yes" },
            { "label": "NO", "value": "no" }
          ],
          "helperText": "Upload a picture of the dustbin inside the toilet",
          "fields": [
            {
              "id": "photo",
              "type": "file",
              "label": "Capture or upload photo",
              "accept": "image/*",
              "helperText": "Upload a picture of the dustbin inside the toilet",
              "capture": "environment",
              "showWhen": ["yes"]
            }
          ]
        }
      ]
    },
    {
      "id": "g",
      "title": "Waste Management",
      "questions": [
        {
          "id": "G.1",
          "label": "G.1",
          "question": "Are there coloured bins (green and blue) for waste segregation (bio and non-biodegradable waste) near kiosk",
          "type": "radio",
          "options": [
            { "label": "YES", "value": "yes" },
            { "label": "NO", "value": "no" }
          ],
          "helperText": "",
          "fields": []
        },
        {
          "id": "G.2",
          "label": "G.2",
          "question": "Whether IEC on waste segregation is displayed near the waste bins?",
          "type": "radio",
          "options": [
            { "label": "YES", "value": "yes" },
            { "label": "NO", "value": "no" }
          ],
          "helperText": "Upload the picture for verification",
          "fields": [
            {
              "id": "photo",
              "type": "file",
              "label": "Capture or upload photo",
              "accept": "image/*",
              "helperText": "Upload the picture for verification",
              "capture": "environment",
              "showWhen": ["yes"]
            }
          ]
        },
        {
          "id": "G.3",
          "label": "G.3",
          "question": "Waste bins cleaned everyday after emptying the waste and recorded in housekeeping checklist. (Check the housekeeping checklist, if record is up to date, assign YES)",
          "type": "radio",
          "options": [
            { "label": "YES", "value": "yes" },
            { "label": "NO", "value": "no" }
          ],
          "helperText": "Upload the housekeeping checklist record for verification",
          "fields": [
            {
              "id": "file",
              "type": "file",
              "label": "Upload supporting file",
              "accept": "image/*,.pdf,.doc,.docx",
              "helperText": "Upload the housekeeping checklist record for verification",
              "showWhen": ["yes"]
            }
          ]
        },
        {
          "id": "G.4",
          "label": "G.4",
          "question": "Is single-use plastic being used in the kiosk?",
          "type": "radio",
          "options": [
            { "label": "YES", "value": "yes" },
            { "label": "NO", "value": "no" }
          ],
          "helperText": "",
          "fields": []
        }
      ]
    },
    {
      "id": "h",
      "title": "Hygiene",
      "questions": [
        {
          "id": "H.1",
          "label": "H.1",
          "question": "Do the staff wear appropriate protective gear in kiosk while distributing food and cleaning? i. apron, cap, mask and food handling gloves during serving food ii. apron and utility gloves while cleaning the kiosk and its surroundings.",
          "type": "radio",
          "options": [
            { "label": "YES", "value": "yes" },
            { "label": "NO", "value": "no" }
          ],
          "helperText": "Upload the picture of staff wearing PPE while doing activities",
          "fields": [
            {
              "id": "photo",
              "type": "file",
              "label": "Capture or upload photo",
              "accept": "image/*",
              "helperText": "Upload the picture of staff wearing PPE while doing activities",
              "capture": "environment",
              "showWhen": ["yes"]
            }
          ]
        },
        {
          "id": "H.2",
          "label": "H.2",
          "question": "Is there a functional handwashing station near the food distribution point for staff and beneficiaries? (* Functional handwashing station must have a handwashing area with running water, soap for handwash, unbroken and no leakage taps, outlet pipe connected to a proper drainage system). (If all the above conditions are available, respond YES)",
          "type": "radio",
          "options": [
            { "label": "YES", "value": "yes" },
            { "label": "NO", "value": "no" }
          ],
          "helperText": "Upload the picture of the handwashing station near kiosk area",
          "fields": [
            {
              "id": "photo",
              "type": "file",
              "label": "Capture or upload photo",
              "accept": "image/*",
              "helperText": "Upload the picture of the handwashing station near kiosk area",
              "capture": "environment",
              "showWhen": ["yes"]
            }
          ]
        },
        {
          "id": "H.3",
          "label": "H.3",
          "question": "Is there a water stagnation in the surrounding area of handwashing station or drain?",
          "type": "radio",
          "options": [
            { "label": "YES", "value": "yes" },
            { "label": "NO", "value": "no" }
          ],
          "helperText": "",
          "fields": []
        },
        {
          "id": "H.4",
          "label": "H.4",
          "question": "Are the staff aware and practice 6 steps of handwashing before serving food and after cleaning the kiosk? (Observe the moments of hand washing - 1. before serving food 2. after using toilet and 3. After cleaning the kiosk)",
          "type": "radio",
          "options": [
            { "label": "YES", "value": "yes" },
            { "label": "NO", "value": "no" }
          ],
          "helperText": "",
          "fields": []
        },
        {
          "id": "H.5",
          "label": "H.5",
          "question": "Are half-yearly health check-ups conducted for the staff, and are the records properly maintained? (Half yearly health check-ups for staff and maintain record)",
          "type": "radio",
          "options": [
            { "label": "YES", "value": "yes" },
            { "label": "NO", "value": "no" }
          ],
          "helperText": "Upload the last updated record for verification",
          "fields": [
            {
              "id": "file",
              "type": "file",
              "label": "Upload supporting file",
              "accept": "image/*,.pdf,.doc,.docx",
              "helperText": "Upload the last updated record for verification",
              "showWhen": ["yes"]
            }
          ]
        },
        {
          "id": "H.6",
          "label": "H.6",
          "question": "Do the staff maintain personal hygiene (no nail polish, trimmed nails, covered hair, etc.)",
          "type": "radio",
          "options": [
            { "label": "YES", "value": "yes" },
            { "label": "NO", "value": "no" }
          ],
          "helperText": "",
          "fields": []
        }
      ]
    },
    {
      "id": "i",
      "title": "Food Hygiene",
      "questions": [
        {
          "id": "I.1",
          "label": "I.1",
          "question": "What type of plates are used for serving food to the beneficiaries? If other material or NA, please specify in the remark coloumn what material plates are used or how the food is distributed.",
          "type": "radio",
          "options": [
            { "label": "Thermocol plates", "value": "thermocol_plates" },
            { "label": "Aluminium foil plates", "value": "aluminium_foil_plates" },
            { "label": "Other material", "value": "other_material" },
            { "label": "Not applicable", "value": "not_applicable" }
          ],
          "helperText": "",
          "fields": [
            {
              "id": "remark",
              "type": "textarea",
              "label": "Remarks",
              "placeholder": "Enter remarks",
              "showWhen": ["other_material", "not_applicable"]
            }
          ]
        }
      ]
    },
    {
      "id": "j",
      "title": "IEC & Monitoring",
      "questions": [
        {
          "id": "J.1",
          "label": "J.1",
          "question": "Are the posters on handwashing, safe toilet use, etc. displayed in the canteen?",
          "type": "radio",
          "options": [
            { "label": "YES", "value": "yes" },
            { "label": "NO", "value": "no" }
          ],
          "helperText": "",
          "fields": []
        },
        {
          "id": "J.2",
          "label": "J.2",
          "question": "Whether regular Online Entry being done in Online Portal?",
          "type": "radio",
          "options": [
            { "label": "YES", "value": "yes" },
            { "label": "NO", "value": "no" }
          ],
          "helperText": "",
          "fields": []
        },
        {
          "id": "J.3",
          "label": "J.3",
          "question": "Whether Daily entry being reconciled with Number of Coupon distributed?",
          "type": "radio",
          "options": [
            { "label": "YES", "value": "yes" },
            { "label": "NO", "value": "no" }
          ],
          "helperText": "",
          "fields": []
        }
      ]
    },
    {
      "id": "k",
      "title": "Challenges & Suggesstion",
      "questions": [
        {
          "id": "1",
          "label": "1",
          "question": "Challenges (If Any)",
          "type": "textarea",
          "options": [],
          "helperText": "",
          "fields": []
        },
        {
          "id": "2",
          "label": "2",
          "question": "Sugesstions (If Any)",
          "type": "textarea",
          "options": [],
          "helperText": "",
          "fields": []
        }
      ]
    }
  ]
};

export default kioskSurveyForm;